export const menuStructure = [
  {
    category: 'Management & Analyse',
    section: 'BI & Management',
    items: [
      { title: 'Produktion & MES (BI)', route: '/bi/produktion' },
      { title: 'Finanzen (BI)', route: '/bi/finanzen' },
      { title: 'SCM (BI)', route: '/bi/scm' },
      { title: 'Sales & CRM (BI)', route: '/bi/sales' },
      { title: 'Prozess-Monitor', route: '/bi/prozess-monitor' },
      { title: 'BI Engine', route: '/bi/dashboard-builder' },
    ]
  },
  {
    category: 'Core Business',
    section: 'MES & Produktion',
    items: [
      { title: 'Shopfloor (MES)', route: '/produktion/mes-fertigung' },
      { title: 'Kapazitätsplanung', route: '/produktion/kapazitaetsplanung' },
      { title: 'Production Flows', route: '/produktion/flows' },
      { title: 'Qualitätsmanagement', route: '/produktion/qm' },
      { title: 'Betriebsdaten (BDE)', route: '/produktion/arbeitszeiten' },
    ]
  },
  {
    category: 'Core Business',
    section: 'SCM & Logistik',
    items: [
      { title: 'Lieferanten & Einkauf', route: '/sortiment/einkauf' },
      { title: 'Wareneingang', route: '/logistik-lager/inventory' },
      { title: 'Lagerverwaltung', route: '/logistik-lager/bestand' },
      { title: 'Versand & Auslieferung', route: '/logistik-lager/versand' },
    ]
  },
  {
    category: 'Core Business',
    section: 'CRM & Sales',
    items: [
      { title: 'Kundenakte (CRM)', route: '/verwaltung/kunden' },
      { title: 'Preislisten (Katalog)', route: '/crm-sales/preislisten' },
      { title: 'Angebote', route: '/crm-sales/angebote' },
      { title: 'Aufträge / Sales', route: '/crm-sales/auftraege' },
      { title: 'Zentrales OMS', route: '/crm-sales/oms' },
      { title: 'Abo-Rechnungslauf', route: '/crm-sales/abo-lauf' },
      { title: 'Points of Sale', route: '/crm-sales/maerkte' },
      { title: 'Debitoren', route: '/crm-sales/debitoren' },
      { title: 'E-Commerce Fulfillment', route: '/crm-sales/woocommerce' },
    ]
  },
  {
    category: 'Core Business',
    section: 'Finanzen & Controlling',
    items: [
      { title: 'Overview', route: '/finanzen-controlling/overview' },
      { title: 'Ausgaben', route: '/finanzen-controlling/ausgaben' },
      { title: 'Bank & Kasse', route: '/finanzen-controlling/bank' },
      { title: 'Analyse', route: '/finanzen-controlling/analyse' },
      { title: 'DATEV Management', route: '/finanzen-controlling/datev' }
    ]
  },
  {
    category: 'Organisation & Support',
    section: 'Workspace',
    items: [
      { title: 'Meine Aufgaben', route: '/allgemein/kanban' },
      { title: 'Dokumente', route: '/allgemein/dokumente' },
      { title: 'Workflows', route: '/allgemein/workflows' },
      { title: 'Whiteboard', route: '/allgemein/whiteboard' },
      { title: 'Checklisten', route: '/allgemein/checklisten' },
      { title: 'Templates', route: '/allgemein/templates' },
    ]
  },
  {
    category: 'Organisation & Support',
    section: 'Compliance & Support',
    items: [
      { title: 'Wissensdatenbank (DCS)', route: '/organisation/compliance' },
      { title: 'Altes Recht (Vergleich)', route: '/allgemein/recht' },
    ]
  },
  {
    category: 'Organisation & Support',
    section: 'HR & Personal',
    items: [
      { title: 'Abteilungen', route: '/verwaltung/abteilungen' },
      { title: 'Personal', route: '/verwaltung/personal' },
    ]
  },
  {
    category: 'Organisation & Support',
    section: 'Projektmanagement',
    items: [
      { title: 'Dashboard', route: '/projektmanagement/dashboard' },
      { title: 'Projekte', route: '/projektmanagement/projekte' },
      { title: 'Kanban-Board', route: '/projektmanagement/kanban' },
      { title: 'Timeline', route: '/projektmanagement/timeline' },
      { title: 'Kalender', route: '/projektmanagement/kalender' },
      { title: 'Chatroom', route: '/nachrichten/chatroom' },
      { title: 'AI Bot', route: '/nachrichten/ai-bot' },
    ]
  },
  {
    category: 'System & Verwaltung',
    section: 'Stammdaten',
    items: [
      { title: 'Katalog & Sortiment', route: '/stammdaten/katalog' },
      { title: 'Produktions-Setup', route: '/stammdaten/produktion' },
    ]
  },
  {
    category: 'System & Verwaltung',
    section: 'Einstellungen',
    items: [
      { title: 'Unternehmensdaten', route: '/verwaltung/firma' },
      { title: 'Rechte & Rollen', route: '/verwaltung/rechte-rollen' },
    ]
  },
  {
    category: 'System & Verwaltung',
    section: 'Administration',
    items: [
      { title: 'Deployment', route: '/administration/deployment' },
      { title: 'Freischaltung', route: '/administration/freischaltung' },
      { title: 'Compliance', route: '/administration/anforderungen' },
      { title: 'IT', route: '/administration/it' },
      { title: 'Audit Logs', route: '/administration/audit-logs' },
      { title: 'Integrationen', route: '/administration/integrationen' },
      { title: 'Datenimport', route: '/administration/datenimport' },
      { title: 'Info', route: '/administration/info' },
    ]
  },
  {
    category: 'System & Verwaltung',
    section: 'System-Handbuch',
    items: [
      { title: 'Handbuch', route: '/system-handbuch' }
    ]
  }
];

const TOOL_MAPPING = {
  'Dokumente': 'Dokumente',
  'Workflows': 'Workflows',
  'Shopfloor (MES)': 'Produktion',
  'Kapazitätsplanung': 'Produktion',
  'Production Flows': 'Sortiment',
  'Betriebsdaten (BDE)': 'Produktion',
  'Versand & Auslieferung': 'Produktion',
  'Arbeitszeiten': 'Produktion',
  'Lagerverwaltung': 'Produktion',
  'Lieferanten & Einkauf': 'Einkauf',
  'Wareneingang': 'Produktion',
  'Einnahmen': 'Einnahmen',
  'Aufträge / Sales': 'Einnahmen',
  'Points of Sale': 'Einnahmen',
  'Woocommerce': 'Woocommerce',
  'Ausgaben': 'Ausgaben',
  'DATEV Management': 'Ausgaben',
  'Dashboard': 'Basis',
  'Projekte': 'Kanban',
  'Kanban-Board': 'Kanban',
  'Timeline': 'Kanban',
  'Kalender': 'Kanban',
  'Whiteboard': 'Kanban',
  'Checklisten': 'Basis',
  'Templates': 'Basis',
  'Wissensdatenbank (DCS)': 'Basis',
  'Altes Recht (Vergleich)': 'Basis',
  'Einkauf (SCM)': 'Einkauf',
  'Katalog & Sortiment': 'Produkte',
  'Produktions-Setup': 'Produktion',
  'Chatroom': 'Chatroom',
  'AI Bot': 'AI Bot',
  'Debitoren': 'Einnahmen',
  'Qualitätsmanagement': 'Produktion',
};

export function getFilteredMenuStructure() {
  try {
    const envLicensedTools = process.env.REACT_APP_LICENSED_TOOLS;
    const localLicensedTools = localStorage.getItem('react_app_licensed_tools');
    const licensedStr = localLicensedTools !== null ? localLicensedTools : envLicensedTools;

    if (licensedStr === undefined || licensedStr === null) {
      return menuStructure;
    }

    const licensedTools = licensedStr
      .split(',')
      .map(t => t.trim().toLowerCase())
      .filter(Boolean);

    const filtered = menuStructure
      .map(section => {
        if (section.section === 'Administration') {
          return section;
        }

        const filteredItems = section.items.filter(item => {
          const requiredTool = TOOL_MAPPING[item.title];
          if (!requiredTool) {
            return true;
          }

          if (item.title === 'Woocommerce') {
            const hasWoo = licensedTools.includes('woocommerce');
            const hasProdAndEinkauf = licensedTools.includes('produkte') && licensedTools.includes('einkauf');
            return hasWoo || hasProdAndEinkauf;
          }

          return licensedTools.includes(requiredTool.toLowerCase());
        });

        if (filteredItems.length === 0) return null;

        return {
          ...section,
          items: filteredItems
        };
      })
      .filter(Boolean);

    return filtered;
  } catch (e) {
    console.error('[SaaS] Error filtering menu structure:', e);
    return menuStructure;
  }
}

export function getActiveSection(pathname) {
  const activeMenu = getFilteredMenuStructure();
  return activeMenu.find(s => s.items.some(i => pathname === i.route)) || null;
}
